import React from 'react';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import Badge from 'components/common-components/Badge';
import FormButton from 'components/form-components/FormButton';
import FormLoadingButton from 'components/form-components/FormLoadingButton';
import { DEV_ONLY } from 'config/config';

const ButtonSamples = () => {
  const auth = useSelector((state) => state.auth);

  const copyToken = () => {
    if (auth.authToken)
      setTimeout(() => {
        navigator.clipboard.writeText(auth.authToken);
        toast.success('Copied Token to clipboard');
      }, 0);
  };

  return (
    <div className='theme-background-white-1'>
      {DEV_ONLY && (
        <div className='d-flex gap-4 align-items-center py-3'>
          <h1>Actions</h1>
          <FormButton text={'Copy Token'} variant='green-1' onClick={copyToken} />
        </div>
      )}
      <div className='d-flex gap-4'>
        <div className='flex-grow-1'>
          <h1>Buttons</h1>
          <div className='d-flex flex-column gap-3 p-4'>
            {[
              'green-1',
              'green-2',
              'green-3',
              'white-1',
              'white-2',
              'grey-1',
              'grey-2',
              'red-1',
              'red-2',
              'red-3',
              'red-4',
              'blue-1',
              'blue-2',
              'blue-3',
              'orange-1',
              'orange-2',
            ].map((variant, index) => (
              <div className='w-50 d-flex gap-2' key={index}>
                <h5 style={{ width: 150 }}>{variant}</h5>
                <FormButton text='Text' variant={variant} />
                <FormButton text='Text' disabled={true} variant={variant} />
                <FormLoadingButton text='Text' loading={true} variant={variant} />
              </div>
            ))}
          </div>
        </div>
        <div className='flex-grow-1'>
          <h1>Badges</h1>
          <div className='d-flex flex-column gap-3 p-4'>
            {[
              'green-1',
              'green-2',
              'grey-1',
              'grey-2',
              'blue-1',
              'blue-2',
              'orange-1',
              'orange-2',
              'red-1',
              'red-2',
            ].map((variant, index) => (
              <div className='w-50 d-flex gap-4' key={index}>
                <h5 style={{ width: 130 }}>{variant}</h5>
                <Badge text='Text' variant={variant} />
                <Badge text='Text' variant={variant} pill />
                <Badge text='Text' variant={variant} outline />
                <Badge text='Text' variant={variant} outline pill />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ButtonSamples;
